{
  "title": "Gate Exit",
  "subtitle": "Confirm a loaded vehicle has physically left the premises.",
  "add": "New Gate Exit",
  "table": {
    "number": "Gate Exit #",
    "loadingTask": "Loading Task",
    "vehicle": "Vehicle No",
    "exitDateTime": "Exit Date/Time",
    "driverName": "Driver Name",
    "exitedBy": "Exited By"
  },
  "form": {
    "loadingTask": "Loading Task",
    "loadingTaskHelper": "Only Loaded tasks without a recorded gate exit are shown.",
    "vehicleNo": "Vehicle No",
    "driverName": "Driver Name",
    "securityRemarks": "Security Remarks"
  },
  "save": "Save",
  "cancel": "Cancel"
}
